import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';


export const lastAlert = createAction(types.ALERT_LAST, (lastAlert:any) => ({
    payload: lastAlert,
}));
